module.exports = __webpack_public_path__ + "static/media/logo-small.e3501615.svg";